import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import {ProductService} from "../../../api/product/product.service";
import store from './../../../store/store.module';
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[productImage]'
})
export class ProductImageDirective {
  public store = store;
  @Input('productImage') data: any;
  constructor(private productService: ProductService, private element: ElementRef) { }

  @HostListener('error', ['$event']) onImageError(event: any) {
    // let realImage = this.element.nativeElement.src;
    // this.productService.reloadImage(realImage).toPromise().then(() => {}, err => console.log('err'));
    // this.element.nativeElement.src = store.getState().RootReducer.config.mediaUrl + '/misc/image-coming/120x120/1.jpg';
  }
}
